<template>
    <div class="setup-page">
        <form action="" method="post">
            <h2 class="first-title">Set up IntelliBoard.Admin to work for your business</h2>
            <h2 class="finish-title" v-bind:class="{active:finishActive}">Your IntelliBoard.Admin account is ready to go!</h2>
            <ul class="setup-tabs">
                <li class="setup-tabs-item active">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    Account
                </li>
                <li class="setup-tabs-item"  v-bind:class="{active: secondActive}">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    Company
                </li>
                <li class="setup-tabs-item">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    Goals
                </li>
            </ul>
            <div class="setup-info active">
                <div class="form-group">
                    <label for="">Company</label>
                    <input type="text" class="form-control">
                </div>
                <div class="form-group">
                    <label for="">Work Phone(optional)</label>
                    <input type="tel" class="form-control">
                </div>
                <div class="form-group clearfix">
                    <label for="">
                        number of people we message
                    </label>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">0 - 15,000</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">15,000 - 50,000</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">50,000 - 100,000</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">100,000 - 250,000</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">250,000 - 500,000</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">500,000 +</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="span-check">
                        <label>
                            <input type="checkbox" name="" id=""> <span></span> I agree to the <a href="">Terms of Service</a>
                        </label>
                    </div>
                </div>
                <div class="form-group text-right">
                    <a href="" v-on:click="addClass" class="setup-page-link">Continue</a>
                </div>
            </div>
            <div class="setup-info" v-bind:class="{active: secondActive}">
                <div class="form-group clearfix">
                    <label for="">
                        my primary messaging goal is:
                    </label>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">
                            Personalize messages and workflows
                        </span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">
                            Send messages with many channels
                        </span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">
                            Improve conversion and perfomance
                        </span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">Save time with automation</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">Consolidate messaging system</span>
                    </div>
                    <div class="setup-page-check">
                        <input type="radio" name="peoples" id="">
                        <span class="setup-page-check-text">
                            Other
                            <br>
                            &nbsp;
                        </span>
                    </div>
                </div>
                <div class="form-group text-right">
                    <a href="">Skip</a>
                    <a href="" class="setup-page-link" v-on:click="finish">Continue</a>
                </div>
            </div>
            <div class="setup-info" v-bind:class="{active:finishActive}">
                <div class="form-group">
                    <label for="">
                        i heard about IntelliBoard.Admin from:
                    </label>
                    <select name="" id="" class="form-control setup-page-select">
                        <option value="">I search engine(like Google)</option>
                        <option value="">1</option>
                        <option value="">1</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="">additional information</label>
                    <textarea name="" id="" cols="30" rows="10" class="form-control setup-page-textarea" placeholder="Please share any details about how you found IntelliBoard.Admin - it hepl us to improve!"></textarea>
                </div>
                <div class="form-group text-right">
                    <a href="" class="setup-page-link">Go to my account!</a>
                </div>
            </div>

        </form>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                secondActive: false,
                finishActive: false,
            }
        },
        methods: {
            addClass: function (e){
                e.preventDefault();
                let folder = document.querySelectorAll('.setup-info');
                folder.forEach(function(el){
                    el.classList.remove('active')
                });
                this.secondActive = true;
            },
            finish: function (e){
                e.preventDefault();
                let folder = document.querySelectorAll('.setup-info');
                folder.forEach(function(el){
                    el.classList.remove('active')
                });
                this.finishActive = true;
                document.querySelector('.first-title').style.display = 'none';
                document.querySelector('.setup-tabs').style.display = 'none';
            }
        }

    }

</script>
